import { READ_SETUP_TECH, UPDATE_SETUP_TECH } from '../config/actionTypes';

const initialState = {
	DISTRIBUTION_EMAIL: '',
	AUTOMATED_EMAIL_SERVER: '',
	AUTOMATED_EMAIL_PORT: '587',
	AUTOMATED_EMAIL_USER: '',
	AUTOAMTED_EMAIL_PASSWORD: '',
	RECEIVING_EMAIL: '',
	STORAGE_TYPE: '',
	STORAGE_REGION: 'us-east-1',
	STORAGE_KEY: '',
	STORAGE_SECRET: '',
	SERVER_TYPE: 'on-premise',
	DOMAIN_TYPE: 'production',
	EXCHANGE_CLIENT_URL: 'http://example.com',
	EXCHANGE_SERVER_URL: 'http://localhost',
	HOLLAEX_CONFIGMAP_CAPTCHA_SITE_KEY: '',
	HOLLAEX_SECRET_CAPTCHA_SECRET_KEY: ''
};

const StatReducer = (state = initialState, action) => {
	switch (action.type) {
		case READ_SETUP_TECH:
			return { ...state, ...initialState };
		case UPDATE_SETUP_TECH:
			const newState = { ...state, ...action.data };
			return newState;
		default:
			return state;
	}
};

export default StatReducer;
